import { render } from "./FavoritesPopover.vue?vue&type=template&id=b96e507c"
import script from "./FavoritesPopover.vue?vue&type=script&lang=js"
export * from "./FavoritesPopover.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__